interface Props {
  dirty: boolean
  operation: 'save' | 'confirm' | null
  failure: string | null
  valid: boolean
  token: string | null
  teamSelected: boolean
  errors: unknown[]
}

export function importDiagnosticText(value: unknown): string {
  if (typeof value === 'string') return value
  if (value && typeof value === 'object' && 'message' in value) return String(value.message)
  return JSON.stringify(value)
}

export default function ImportConfirmationStatus({ dirty, operation, failure, valid, token, teamSelected, errors }: Props) {
  return <div id="confirmation-status" aria-live="polite" className="space-y-2 text-sm text-text-primary">
    {operation && <p>{operation === 'save' ? 'Saving mappings and refreshing the preview. Confirmation is unavailable until this finishes.' : 'Import request in progress. Wait for the result before taking another action.'}</p>}
    {failure && <p role="alert" className="text-pinnacle-red">{failure}</p>}
    {dirty && <p>Unsaved mapping or checkbox changes. Use “Save mappings &amp; refresh preview” to review and authorize these changes.</p>}
    {!teamSelected && <p><a className="underline" href="#import-mapping">Select a destination team in the mappings.</a></p>}
    {!dirty && (!valid || errors.length > 0) && <div>
      <p className="font-semibold">Validation errors block confirmation:</p>
      {errors.length > 0 ? <ul className="list-disc pl-5">{errors.map((error, index) => <li key={index}>{importDiagnosticText(error)}</li>)}</ul> : <p>The server has not returned a valid preview. Save mappings and refresh to validate again.</p>}
      <a className="underline mr-3" href="#import-mapping">Review mappings and consents</a>
      <a className="underline" href="#import-records">Review affected records</a>
    </div>}
    {!dirty && valid && !token && <p>Review authorization is missing or expired. Use “Save mappings &amp; refresh preview” to request fresh authorization without discarding your edits.</p>}
  </div>
}
